import _fails from "../internals/fails";
import _createPropertyDescriptor from "../internals/create-property-descriptor";
var exports = {};
var fails = _fails;
var createPropertyDescriptor = _createPropertyDescriptor;
exports = !fails(function () {
  var error = new Error("a");
  if (!("stack" in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, "stack", createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});
export default exports;